import React from "react";
import Footer from "./Footer";
import NavBar from "./NavBar";
import { useMediaQuery, useTheme } from "@mui/material";

const AnnualCompliancePrivateLimited = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md")); // Mobile breakpoint at 900px

  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f5f5f5",
        margin: 0,
        padding: 0,
      }}
    >
      <NavBar />

      {/* Header */}
      <div
        style={{
          backgroundColor: "#00b050",
          color: "white",
          padding: isMobile ? "15px" : "30px",
          fontSize: isMobile ? "20px" : "28px",
          fontWeight: "bold",
          textAlign: "center",
          marginTop: "65px",
        }}
      >
        Annual Compliance for Private Limited Company
      </div>

      {/* Intro Paragraph */}
      <p
        style={{
          maxWidth: isMobile ? "100%" : "1200px",
          width: "95%",
          margin: isMobile ? "10px auto" : "20px auto",
          padding: isMobile ? "10px" : "20px",
          fontSize: isMobile ? "14px" : "16px",
        }}
      >
        A Private Limited Company, recognized as a distinct legal entity, must
        maintain its active status by adhering to mandatory annual filings with
        the Ministry of Corporate Affairs (MCA), regardless of turnover or
        business activity.
      </p>

      {/* Content */}
      <div
        style={{
          maxWidth: isMobile ? "100%" : "1200px",
          width: "95%",
          margin: isMobile ? "10px auto" : "15px auto",
          padding: isMobile ? "10px" : "20px",
        }}
      >
        <div
          style={{
            background: "white",
            padding: isMobile ? "15px" : "25px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            lineHeight: "1.6",
            color: "#333",
          }}
        >
          {/* Legal Framework */}
          <div>
            <h2
              style={{
                color: "#001F3F",
                fontWeight: 600,
                marginBottom: isMobile ? "4px" : "6px",
                fontFamily: "Times New Roman, Georgia, serif",
                fontSize: isMobile ? "18px" : "24px",
              }}
            >
              Legal Framework
            </h2>
            <div
              style={{
                width: "80px",
                height: "3px",
                background: "#22c55e",
                borderRadius: "2px",
              }}
            ></div>
          </div>

          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Every Private Limited Company must file an annual return and audited
            financial statements with the MCA for each fiscal year, a
            requirement that applies irrespective of turnover—zero or in
            crores—or whether any business is conducted. Failure to comply
            consistently may result in the company’s name being struck off the
            Registrar of Companies (RoC) register, alongside potential director
            disqualification.
          </p>

          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            These filings, aligned with the Annual General Meeting (AGM)
            schedule, report the company’s activities and financial data. The MCA
            has intensified efforts to enforce compliance, categorizing
            obligations into mandatory and event-based requirements.
          </p>

          {/* Mandatory Obligations */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Mandatory Obligations
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <ol
            style={{
              paddingLeft: isMobile ? "15px" : "20px",
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            <li>
              <strong>First Board Meeting:</strong> To be held within 30 days of
              incorporation, with a seven-day notice to directors.
            </li>
            <li>
              <strong>Subsequent Board Meetings:</strong> At least four annually,
              with no more than 120 days between meetings.
            </li>
            <li>
              <strong>Director Interest Disclosure (Form MBP-1):</strong> Filed
              at the first meeting, annually, or upon disclosure changes, listing
              interests and relatives’ involvement.
            </li>
            <li>
              <strong>First Auditor Appointment:</strong> Designated within 30
              days of incorporation, serving until the first AGM, with no ADT-1
              filing required.
            </li>
            <li>
              <strong>Subsequent Auditor Appointment:</strong> Appointed at the
              first AGM for six years, with ADT-1 filed by the company within 15
              days.
            </li>
            <li>
              <strong>Annual General Meeting (AGM):</strong> Held by September
              30th annually, between 9 am and 6 pm, with a 21-day notice,
              excluding public holidays.
            </li>
            <li>
              <strong>Annual Return Filing (Form MGT-7):</strong> Due within 60
              days of the AGM, covering April 1st to March 31st.
            </li>
            <li>
              <strong>Financial Statements Filing (Form AOC-4):</strong> Submitted
              within 30 days of the AGM, including balance sheet, profit/loss
              statement, and director report.
            </li>
            <li>
              <strong>Statutory Audit:</strong> Accounts must be audited by a
              chartered accountant, with an audit report and financial statements
              filed with the RoC.
            </li>
          </ol>

          {/* Event-Driven Requirements */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Event-Driven Requirements
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Event-based compliances arise from specific changes, such as
            alterations in directors, registered office, or share capital,
            requiring timely action to avoid penalties. Key examples include:
          </p>
          <ul
            style={{
              paddingLeft: isMobile ? "15px" : "20px",
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            <li>
              <strong>Change in Registered Office (INC-22):</strong> Within 15
              days of change.
            </li>
            <li>
              <strong>Change in Directors or KMP (DIR-12):</strong> Within 30 days
              of change.
            </li>
            <li>
              <strong>Increase in Authorized Share Capital (SH-7):</strong>
              Within 30 days of resolution.
            </li>
            <li>
              <strong>Filing Resolutions (MGT-14):</strong> Within 30 days of
              resolution passage.
            </li>
            <li>
              <strong>Increase in Paid-Up Share Capital (PAS-3):</strong> Within
              15 days of allotment.
            </li>
            <li>
              <strong>Change in Secured Borrowing (CHG-1):</strong> Within 30
              days of charge creation/modification.
            </li>
            <li>
              <strong>Director KYC (DIR-3 KYC):</strong> By April 30th of the
              next financial year.
            </li>
            <li>
              <strong>ACTIVE Compliance (INC-22A):</strong> By April 25, 2019,
              for companies registered before December 31, 2017.
            </li>
            <li>
              <strong>Commencement Declaration (INC-20A):</strong> Within 180
              days of incorporation for companies post-November 2, 2018.
            </li>
          </ul>

          {/* Compliance Consequences */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Compliance Consequences
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Non-compliance with administrative obligations results in fines for
            the company and its officers, escalating with the duration of
            default. Persistent failure may lead to deregistration or director
            disqualification, with a penalty of ₹100 per day of delay since July
            2018.
          </p>

          {/* Startup Compliance Checklist */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Startup Compliance Checklist
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Startups as private limited companies must adhere to statutory
            requirements, including:
          </p>
          <ul
            style={{
              paddingLeft: isMobile ? "15px" : "20px",
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            <li>Monthly/Quarterly GST and TDS returns.</li>
            <li>Periodic advance tax assessment and payment.</li>
            <li>
              Income tax returns at a 30% rate plus cess, with tax audit
              reports.
            </li>
            <li>
              Regulatory assessments under acts like the Environment Protection
              Act or Competition Act.
            </li>
          </ul>

          {/* Required Documentation */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Required Documentation
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Essential documents include the incorporation certificate, PAN card,
            MoA-AoA, audited financial statements, audit and board reports, and a
            valid Digital Signature Certificate (DSC) of a director.
          </p>

          {/* Operational Insights */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Operational Insights
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Managing a private limited company demands significant time,
            financial expertise, and adherence to regulatory technicalities.
            Compliance, when executed effectively, fosters credibility, investor
            trust, and a transparent business culture.
          </p>

          {/* Concluding Perspective */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Concluding Perspective
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Annual compliance is a vital component of sustaining a private
            limited company’s legal and operational integrity. Leveraging expert
            assistance can mitigate the costs of non-compliance, which invariably
            exceed compliance expenses, ensuring long-term success.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default AnnualCompliancePrivateLimited;